export default "__VITE_ASSET__BQuUu5PB__"